import { Injectable, OnDestroy } from '@angular/core';
import { Subject, filter, forkJoin, takeWhile } from 'rxjs';
import { APIUrls, AppSide, AppStatesTexts, MNGUrls, UserRoles } from 'src/app/constants';
import { CreatePartnerModel, PartnerDataModel } from '../models/accountModel';
import { BaseService } from 'src/app/base.service';
import { NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'src/app/shared/shared.service';
import { StorageService } from 'src/app/shared/services/storage.service';



@Injectable({
  providedIn: 'root'
})
export class AccountService implements OnDestroy {

  private history: string[] = []

  destroySubscription = false;

  partnerDataModel: PartnerDataModel;

  isLoggedIn = new Subject();

  user = new Subject();

  routerSubscription: any;

  partialLoggedIn = new Subject();

  removeAllStoreGridParams = new Subject();

  constructor(private baseService: BaseService, private router: Router,
    private spinner: NgxSpinnerService, private sharedService: SharedService) {
    this.routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.history.push(event.urlAfterRedirects);
        if (event && event.url && event.url.indexOf('&state=') > -1) {
          this.partialLoggedIn.next(true);
        }
      })
    this.partnerDataModel = {} as PartnerDataModel;
  }

  logout() {
    this.removeAllStoreGridParams.next(true);
    this.sharedService.removeBranding();
    this.sharedService.removeStoreMetadata();
    this.removeUser();
    // location.reload();
    location.replace(window.location.origin);
  }

  public getUser(): any {
    return this.sharedService.getStoreUser();
  }

  public removeUser() {
    this.sharedService.removeStoreUser();
  }

  isAuthenticated() {
    const user = this.getUser();
    if (user) {
      return true;
    }
    return false;
  }

  checkLoggedInAndNavigateToMain() {
    if (this.isAuthenticated()) {
      this.router.navigate(['/dashboard/main']);
    }
  }

  login(shortname: string) {
    this.baseService.getDataText(APIUrls.loginPartner + shortname)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
          }
        }
      });
  }

  registerPartner(createPartnerModel: CreatePartnerModel) {
    const createPartnerModelNew = JSON.parse(JSON.stringify(createPartnerModel));
    createPartnerModelNew.contact_num = (createPartnerModelNew.contact_num).replace(/[-\(\)\.\s\+]/g, '');
    this.postRequest(createPartnerModelNew, MNGUrls.registerPartner + '?invite-code=' + createPartnerModel.invite_code)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.authenticatePartner(response.body.partner_id);
          }
        }
      });
  }

  authenticatePartner(partner_id: any) {
    this.baseService.getDataText(APIUrls.authenticatePartner + partner_id)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
          }
        }
      });
  }

  getMetadataNBrandingData(user: PartnerDataModel) {
    this.spinner.show();
    const user_role = user.user_role;
    let brandingUrl = APIUrls.partnerApps + user.partner_id;
    switch (user_role) {
      case UserRoles.superuser:
        brandingUrl = brandingUrl + '/reseller/' + user.reseller_name + '/branding?user-domain=' + user.user_domain;
        break;
      case UserRoles.reseller:
        brandingUrl = brandingUrl + '/reseller/' + user.reseller_name + '/branding?user-domain=' + user.user_domain;
        break;
      case UserRoles.officemanager:
        brandingUrl = brandingUrl + '/reseller/' + user.reseller_name + '/customer/' + user.customer_name + '/branding';
        break;
      default:
        brandingUrl = brandingUrl + '/branding?user-domain=' + user.user_domain;
        break;
    }
    const responseA = this.getRequest(brandingUrl);
    const responseB = this.getDataForkJoinSkipIntercept(MNGUrls.metadata);
    forkJoin([responseA, responseB])
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && forkResponse.length) {
          if (forkResponse[0] && forkResponse[0].status === 200 && forkResponse[0].body
            && forkResponse[1] && forkResponse[1].status === 200 && forkResponse[1].body) {
            this.sharedService.brandingDataSub.next(forkResponse[0].body);
            // this.sharedService.appMetaDataSub.next(forkResponse[1].body);
            this.sharedService.saveBranding(forkResponse[0].body);
            this.sharedService.saveStoreMetadata(forkResponse[1].body);
            this.partialLoggedIn.next(false);
            const link = [`${user.short_name}/store/`];
            this.router.navigate(link);
          }
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  goBAck() {
    this.history.pop();
    if (this.history.length > 0) {
      window.history.back();
    } else {
      this.goHome();
    }
  }

  goHome() {
    const user = this.getUser();
    if (user) {
      const link = [`${user.short_name}/store/`];
      this.router.navigate(link);
    } else {
      this.router.navigateByUrl('dashboard/main');
    }
  }

  // goEnabledAppDetails(app: any) {
  //   const user = this.getUser();
  //   let isCustomerUser = false;
  //   if (user.customer_name) {
  //     isCustomerUser = true;
  //   } else {
  //     isCustomerUser = false;
  //   }

  //   if (!isCustomerUser) { // partner scenario
  //     if (!app.enable_state || (app.enable_state && this.sharedService.isPartnerEnabledAppsAllowedToDetilsPage(app))) {
  //       this.navigateToAppDetails(user, app);
  //     }
  //   } else if (isCustomerUser) { // custpomer scenario

  //   }
  // }

  goAppDetails(app: any) {
    const link = [`dashboard/app/${app.app_id}`];
    this.router.navigate(link);
  }

  // goSpotlightAppDetails(app: any) {
  //   const user = this.getUser();
  //   if (user && app.enable_state) {
  //     this.goEnabledAppDetails(app);
  //   } else {
  //     this.goAvailAppDetails(app);
  //   }
  // }

  // navigateToAppDetails(user: any, app: any) {
  //   const link = [`${user.short_name}/app/${app.app_id}`];
  //   this.router.navigate(link);
  // }

  navigateNormal(path: string) {
    this.router.navigate([path]);
  }

  navigateAfterLogin(path: string) {
    const user = this.getUser();
    const link = [`${user.short_name}/${path}`];
    this.router.navigate(link);
  }


  getRequest(reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.getData(reqUrl + (urlData ? urlData : ''));
  }

  postRequest(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.postData(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  getDataForkJoinSkipIntercept(reqUrl: string) {
    return this.baseService.getDataForkJoinSkipIntercept(reqUrl);
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
    this.routerSubscription.unsubscribe();
  }
}
